'use strict';

import SweetScroll from 'sweet-scroll';
import baguetteBox from 'baguettebox.js';

import $ from 'jquery';
import 'slick-carousel';

document.addEventListener(
  'DOMContentLoaded',
  () => {
    /* eslint-disable no-unused-vars */
    // ページ内リンクなどのスムーススクロール
    const sweetScroll = new SweetScroll({
      trigger: 'a[href^="#"]',
      offset: -20
    });
    /* eslint-enable */

    // お知らせクリックで隠す
    $('#notice-close').on('click', function() {
      $('#notice').attr('aria-hidden', true);
    });

    // ナビゲーション開閉
    if ($('#menu-btn').length > 0) {
      $('#menu-btn').on('click', function() {
        $('body').toggleClass('gnav-show');
      });
      // サブメニュー開閉
      $('.gnav__group > .gnav__item:not(:only-child)').on('click', function(event) {
        event.preventDefault();
        $(this)
          .toggleClass('active')
          .next()
          .slideToggle();
      });
    }

    // slick
    // 緊急のお知らせ
    $('.notice__slider')
      .not('.slick-initialized')
      .slick({
        infinite: true,
        speed: 600,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        vertical: true
      });
    // メインビジュアル
    $('.mainvisual__slider')
      .not('.slick-initialized')
      .slick({
        infinite: true,
        speed: 600,
        fade: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 6000,
        cssEase: 'linear'
      });

    // ギャラリー
    baguetteBox.run('.gallery');

    function validate(item) {
      let msg = item.parentNode.querySelector('.error');
      if (item.validity.valueMissing && !msg) {
        msg = document.createElement('span');
        msg.classList.add('error');
        msg.textContent = '未入力です。';
        msg.addEventListener('click', function() {
          item.parentNode.removeChild(msg);
        });
        item.insertAdjacentElement('afterend', msg);
      } else if (!item.validity.valueMissing && msg) {
        item.parentNode.removeChild(msg);
      }
    }

    // フォーム
    const form = document.querySelector('.mw_wp_form form');
    if (form) {
      // Yubinbango用
      form.classList.add('h-adr');

      // デフォルトのバリデーションを無効にする
      form.setAttribute('novalidate', true);

      // バリデーション
      const required = Array.prototype.slice.call(form.querySelectorAll('[required]'), 0);
      // 必須項目をイベントごとにチェック
      required.forEach(function(item) {
        const trigger = ['focusout', 'change', 'keyup'];
        trigger.forEach(function(event) {
          item.addEventListener(event, function() {
            this.classList.add('focused');
            validate(this);
          });
        });
      });

      // エラー項目までスクロールする
      const error = form.querySelector('.error');
      if (error) {
        sweetScroll.to('.error');
      }
    }

    // Instagram
    var code = '';
    $.ajax({
      url: '/get-instagram/',
      type: 'POST',
      dataType: 'json',
      cache: false
    })
      .done(function(data) {
        //通信成功時の処理
        $.each(data.data, function(i, item) {
          if (i >= 10) return false;
          var imgurl = item.images.low_resolution.url;
          var link = item.link;
          code += '<a href="' + link + '" class="list-instagram__item" target="_blank" style="background-image:url(' + imgurl + ');"></a>';
        });
      })
      .fail(function() {
        //通信失敗時の処理
        code = '投稿を取得できません。';
      })
      .always(function() {
        //通信完了時の処理
        if (code.length < 1) code = '投稿がありません。';
        $('#js-instagram').html(code);
      });
  },
  false
);

//リサイズ時の処理を定義
(function() {
  var timer = 0;
  window.onresize = function() {
    if (timer > 0) {
      clearTimeout(timer);
    }
    timer = setTimeout(function() {
      // slick
      // 緊急のお知らせ
      $('.notice__slider')
        .not('.slick-initialized')
        .slick({
          infinite: true,
          speed: 600,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 3000,
          vertical: true
        });
      // メインビジュアル
      $('.mainvisual__slider')
        .not('.slick-initialized')
        .slick({
          infinite: true,
          speed: 600,
          fade: true,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 6000,
          cssEase: 'linear'
        });
    }, 200);
  };
  //gnav子要素hover
  $(function() {
    $('.gnav__group').on('click', function() {
      // return false;
    });
    $('.gnav__group').each(function() {
      $(this).on({
        mouseenter: function() {
          $('.gnav__children', this).addClass('current');
        },
        mouseleave: function() {
          $('.gnav__children', this).removeClass('current');
        }
      });
    });
  });
})();
